

export interface SalesUrlModel {
    HomeUrl: string;
    CartUrl: string;
    CheckoutUrl: string;
    PurchaseUrl: string;
}

export interface SalesUrlTrModel {
    [key: string]: string;
}
